import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Flex } from '@radix-ui/themes';

import { Footer } from '../../../layout/footer/Footer';
import { MenuButtonsList } from '../../../components/menuButton/MenuButtonsList';
import { Page, TransitionUrl, TranslationPath } from '../../../contexts/kioskConfiguration/type';
import useLanguage from '../../../contexts/language/LanguageContext';
import { getTranslationByPath } from '../../../utils/translations';
import {
  setFetchedTransportation, setTransportationForm,
  setTransportationType, transportationFormInitialState
} from '../../../store/slices/transportation/transportationSlice';
import { MainContent } from '../../../layout/content/MainContent';
import { RootState } from '../../../store/store';


export type TransportationTypesTemplateType = {
  label: string
  buttons: {
    label: TranslationPath
    transitionUrl: TransitionUrl
  }[]
}

type Props = {
  page: Page<TransportationTypesTemplateType>
}

export const TransportationTypesTemplate = (props: Props): React.ReactElement => {
  const language = useLanguage()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const transportationForm = useSelector((state: RootState) => state.transportation.transportationForm)


  return (
    <div>
      <MainContent>
        <div className="text-center mb-10">
          {getTranslationByPath(language.translations, props.page.data.label)}
        </div>
        <Flex direction="column" gap="1" width="100%" className="items-center">
          <Box maxWidth="500px" className="w-full flex flex-col items-center text-center">

            <MenuButtonsList buttons={props.page.data.buttons.map((b: any) => {
              return {
                label: getTranslationByPath(language.translations, b.label),
                onClick: () => {
                  dispatch(setTransportationType(b.transportationTypeId))
                  dispatch(setFetchedTransportation(null))
                  dispatch(setTransportationForm({
                    ...transportationFormInitialState,
                    distance: transportationForm.distance,
                  }))
                  navigate(b.transitionUrl)
                },
              }
            })} />
          </Box>
        </Flex>
      </MainContent>
      <Footer backUrl={props.page.footer?.back} />
    </div>
  )
}
